
<nb-card
  [size]="'medium'"
  *ngIf="createDashboardMode"  class="create-dashboard-dropdown"
>
  <nb-card-body class="items">

    <div
      class="item"
      data-testid="create-new-dashboard"
      *ngIf="selectedWorkspace.permissions.get('CreateDashboard').isChecked"
      (click)="createDashboard(); $event.stopPropagation()"
    >
      <morva-icons class="icon" icon="dashboard"></morva-icons>
      داشبورد جدید
    </div>

    <div
      class="item mb-0"
      data-testid="import-dashboard"
      *ngIf="selectedWorkspace.permissions.get('CreateDashboard').isChecked"
      (click)="$event.stopPropagation()"
    >
      <label class="file-upload-label">
        <morva-icons class="icon" icon="uploadDashboard"></morva-icons>
        بارگذاری فایل

        <input
          type="file"
          accept=".tart"
          (change)="onFileSelected($event)"
        />
      </label>
    </div>
  </nb-card-body>
</nb-card>

<div class="side-bar-menu" *ngIf="!loading; else loadingSideBar" data-testid="sidebar">
  <section class="logo d-flex justify-content-between align-items-center pe-3 pt-4 mb-4">
    <div *ngIf="!loading && !logoPath" >&nbsp;</div>
    <img 
      *ngIf="!loading && logoPath" 
      [src]="logoPath" 
      class="mx-2" 
      width="78.4" 
      height="auto" 
      data-testid="sidebar-logo"/>
    <morva-icons 
      data-testid="two-caret-right-outline-icon" 
      icon="towCaretRightOutline" 
      class="mx-2 blue-tart-icon cursor-pointer" 
      data-testid="sidebar-toggle"
      (click)="responsiveMode === 'sm' ? collapseSideBar() : compactedSideBar()">
    </morva-icons>
  </section>
  <div class="footer pe-3 pb-3" [ngClass]="{'mobile-style': responsiveMode === 'sm'}">
    <a *ngIf="versionInfo" [href]="versionInfo.link" target="_blank" data-testid="sidebar-version">نسخه {{versionInfo.number}}</a>
  </div>
  <section class="create-button d-flex flex-column justify-content-center my-4"
    *ngIf="responsiveMode === 'lg' || responsiveMode === 'xl'">
    <a *ngIf="!loading " class="nav-item nav-link" type="button" (click)="toggleCreateAssetMode($event)">

      <button data-testid="create-button" class="d-flex justify-content-between align-items-center" *ngIf="!allWorkspaceMode && (selectedWorkspace.permissions.get('CreateDashboard').isChecked ||
                    selectedWorkspace.permissions.get('CreateDataSource').isChecked)" data-testid="create-disabled-button">
        <p class="m-0">
          <nb-icon icon="plus-outline" status="info"></nb-icon>
          ایجاد
        </p>
        <nb-icon icon="arrow-ios-downward-outline" status="info" *ngIf="!createAssetMode" data-testid="create-arrow-down"></nb-icon>
        <nb-icon icon="arrow-ios-upward-outline" status="info" *ngIf="createAssetMode" data-testid="create-arrow-up"></nb-icon>
      </button>
      <button nbTooltipPlacement="bottom" nbTooltip="لطفاً ابتدا یک فضای کاری انتخاب کنید."
        class="d-flex justify-content-between align-items-center disabled-button" [disabled]="true"
        *ngIf="(allWorkspaceMode && !user.isSuperAdmin) || !(selectedWorkspace.permissions.get('CreateDashboard').isChecked ||
                    selectedWorkspace.permissions.get('CreateDataSource').isChecked)">
        <p class="m-0">
          <nb-icon icon="plus-outline" status="info"></nb-icon>
          ایجاد
        </p>
        <nb-icon icon="arrow-ios-downward-outline" status="info" *ngIf="!createAssetMode"></nb-icon>
        <nb-icon icon="arrow-ios-upward-outline" status="info" *ngIf="createAssetMode"></nb-icon>
      </button>
      <button class="d-flex justify-content-start" *ngIf="allWorkspaceMode && user.isSuperAdmin" data-testid="create-workspace-button"
        (click)="createWorkspace()">
        <p class="m-0 align-items-start">
          <nb-icon icon="plus-outline" status="info"></nb-icon>
          ایجاد فضای کاری
        </p>
      </button>
    </a>

    <!-- <div class="no-display" *ngIf="!loading && !allWorkspaceMode && !(selectedWorkspace.permissions.get('CreateDashboard').isChecked ||
                         selectedWorkspace.permissions.get('CreateDataSource').isChecked)"></div> -->

    <nb-card [size]="'medium'" *ngIf="createAssetMode" class="create-dropdown" data-testid="create-dropdown">
      <nb-card-body class="items">
        <div
        (click)="toggleCreateDashboardMode($event)"
        class="item d-flex justify-content-between align-items-center"
        data-testid="create-dashboard"
        *ngIf="selectedWorkspace.permissions.get('CreateDashboard').isChecked">
      
        <div class="d-flex align-items-center">
          <morva-icons class="icon" icon="dashboard"></morva-icons>
          داشبورد
        </div>
      
        <morva-icons
          icon="caretLeftOutline"
          status="info">
        </morva-icons>
      
      </div>      

        <div (click)="createDatasource()" class="item mb-0" data-testid="create-datasource"
          *ngIf="selectedWorkspace.permissions.get('CreateDataSource').isChecked">
          <morva-icons class="icon" icon="dataSource"></morva-icons>
          منبع داده
        </div>
      </nb-card-body>
    </nb-card>

  </section>

  <!-- Menu Items Section -->
  <section class="menu-items" data-testid="menu-items">
    <div *ngIf="!loading">
      <!-- Main Sidebar Items -->
      <div *ngFor="let item of topSideBarMenu" class="menu-item">
        <a class="menu-parent-item" *ngIf="item.havingAccess"
          [ngClass]="{'lg-mode': responsiveMode === 'lg', 'active': activeLink?.includes(item.link)}"
          (click)="changeTitle(item.title);changeRoute(item.link);">
          <morva-icons [icon]="item.icon" class="d-inline-block menu-icon"
            [ngClass]="{'icon-24': item.icon === 'bookmark'}"></morva-icons>
          <span class="menu-title me-3" data-testid="main-menu-items">{{ item.title | translate }}</span>
        </a>
        <a nbTooltip="دسترسی لازم برای {{item.title}} را ندارید." class="disabled-menu-item" *ngIf="!item.havingAccess"
        [ngClass]="{'lg-mode': responsiveMode === 'lg', 'active': activeLink?.includes(item.link)}"
        >
        <morva-icons [icon]="item.icon" class="d-inline-block menu-icon"
          [ngClass]="{'icon-24': item.icon === 'bookmark'}"></morva-icons>
        <span class="menu-title me-3" data-testid="main-menu-dissable-items">{{ item.title | translate }}</span>
      </a>
        <!-- Sub-menu items for محتویات -->
        <div *ngIf="item.title === 'محتویات'" class="sub-menu" data-testid="submenu-content">
          <div *ngFor="let subAllContentItem of subSideBarAllContentMenu" class=" sub-item">
            <a [ngClass]="{'lg-mode': responsiveMode === 'lg', 'active': activeLink?.includes(subAllContentItem.link) && activeTabId === subAllContentItem.tabId}"
              (click)=" changeRouteWithTab(subAllContentItem.link, subAllContentItem.tabId);">
              <morva-icons [icon]="subAllContentItem.icon" class="d-inline-block menu-icon"></morva-icons>
              <span class="menu-title me-3" data-testid="total-sub-item-links">{{ subAllContentItem.title }}</span>
            </a>
          </div>
        </div>
        <!-- Sub-menu items for نشان‌شده -->
        <div *ngIf="item.title === 'نشان‌شده'" class="sub-menu" data-testid="submenu-bookmarked">
          <div *ngFor="let subBookmarkedItem of subSideBarBookmarkedMenu" class=" sub-item">
            <a [ngClass]="{'lg-mode': responsiveMode === 'lg', 'active':activeLink?.includes(subBookmarkedItem.link) && activeTabId === subBookmarkedItem.tabId}"
              (click)=" changeRouteWithTab(subBookmarkedItem.link,subBookmarkedItem.tabId);">
              <morva-icons [icon]="subBookmarkedItem.icon" class="d-inline-block menu-icon"></morva-icons>
              <span class="menu-title me-3" data-testid="bookmarked-sub-item-links">{{ subBookmarkedItem.title }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Bottom Sidebar Items -->
    <div *ngIf="!loading" class="mt-auto mb-5" data-testid="sidebar-bottom">
      <div *ngFor="let item of bottomSideBarMenu" class="menu-item">
        <a *ngIf="item.havingAccess"
          [ngClass]="{'lg-mode': responsiveMode === 'lg', 'active': activeLink?.includes(item.link)}"
          (click)="changeTitle(item.title);changeRoute(item.link);">
          <morva-icons [icon]="item.icon" class="d-inline-block"></morva-icons>
          <span class="menu-title me-3" data-testid="bottom-sub-item-links">{{ item.title | translate }}</span>
        </a>
      </div>
    </div>
  </section>

  <section (click)="toggleSelectWorkspaceMode($event)" *ngIf="selectedWorkspace" class="selected-workspace">
    <div class="workSpace-list" *ngIf="selectWorkspaceMode">
      <div class="flex-row py-3 mx-2" [ngClass]="responsiveMode === 'lg'? 'px-2':'px-4'" data-testid="selected-workspace">
        <morva-icons icon="inbox" class="d-inline-block"></morva-icons>
        <span class="item-title me-3" data-testid="current-workspace">{{ selectedWorkspace.name }}</span>
        <nb-icon [icon]="selectWorkspaceMode ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'"></nb-icon>
      </div>
      <hr class="my-0" *ngIf="selectWorkspaceMode">
      <div class="workspaces" *ngIf="selectWorkspaceMode">
        <div id="workspace" class="d-flex justify-content-start align-items-center" [ngClass]="{'highlight-workspace': workspace.workspaceId === selectedWorkspace.workspaceId,
                                'lg-mode':responsiveMode === 'lg'}"
          *ngFor="let workspace of workspaces; trackBy: workspacesTrackBy" (click)="selectWorkspace(workspace)">
          <morva-icons icon="inbox" class="ms-2"></morva-icons>
          <span  data-testid="workspace-items" class="item-title me-3">{{ workspace.name }}</span>
        </div>
      </div>
    </div>
    <div *ngIf="!selectWorkspaceMode">
      <div class="flex-row py-2 mx-2 my-1" [ngClass]="responsiveMode === 'lg'? 'px-2':'px-4'">
        <morva-icons icon="inbox" class="d-inline-block"></morva-icons>
        <span class="item-title me-3" [nbTooltip]="selectedWorkspace.name"
          [nbTooltipDisabled]="selectedWorkspace.name.length < 18" data-testid="workspace-current-name">{{ selectedWorkspace.name }}</span>
        <nb-icon icon="arrow-ios-downward-outline"></nb-icon>
      </div>
    </div>
  </section>
</div>

<ng-template #loadingSideBar>
  <div class="side-bar-menu">

    <section class="logo d-flex align-items-center pe-3 pt-4">
      <ngx-skeleton-loader
        [theme]="{'background-color': '#EFEFEF', width: '78px', height: '22px', 'margin-right': '0.5rem', 'margin-top': '0.7rem'}"
        appearance="line"></ngx-skeleton-loader>
    </section>

    <section class="making-button d-flex flex-column justify-content-center">
      <ngx-skeleton-loader
        [theme]="{'background-color': '#CCECF9', width: '216px', height: '42px', 'margin': '65px 18px 27px 32px'}"
        appearance="line"></ngx-skeleton-loader>
    </section>

    <section class="menu-items">
      <ngx-skeleton-loader count="5"
        [theme]="{'background-color': '#EFEFEF', width: '216px', height: '22px', 'margin-right': '18px', 'margin-left': '32px', 'margin-bottom': '23px'}"
        appearance="line"></ngx-skeleton-loader>
      <div *ngIf="loading" class="divider mb-4"></div>
      <ngx-skeleton-loader count="4"
        [theme]="{'background-color': '#EFEFEF', width: '216px', height: '22px', 'margin-right': '18px', 'margin-left': '32px', 'margin-bottom': '23px'}"
        appearance="line"></ngx-skeleton-loader>
    </section>

    <section class="workspace-skeleton">
      <div class="divider mb-3"></div>
      <ngx-skeleton-loader
        [theme]="{'background-color': '#EFEFEF', width: '216px', height: '22px', 'margin-right': '18px', 'margin-left': '32px'}"
        appearance="line"></ngx-skeleton-loader>
    </section>
  </div>
</ng-template>